<template>
  <div class="box">
    <letter-commitment :type="2"></letter-commitment>
  </div>
</template>

<script>
import letterCommitment from "@/components/common/letterCommitment";
export default {
  name: "",
  components: { letterCommitment },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
}
</style>
